import { Tag } from 'api/api-rtk'

import { api } from './api'

export const refetch = () => api.util.invalidateTags([Tag.Executions])
